import React from "react";

import LoaderSpinner from "../../../common/loader/LoaderSpinner";
import { Centered } from "../commonStyles";

const PageLoader = () => (
  <Centered>
    <LoaderSpinner />
  </Centered>
);

export default PageLoader;
